import type React from "react";

import { DialogPanel } from "./DialogPanel";
import { backdropClose } from "./backdrop";

// Peças visuais do portal — mesmos tokens e medidas do Valquiria (index.css).

export const btnPrimary: React.CSSProperties = { background: "var(--brand)", color: "#fff", padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500, border: "none", cursor: "pointer" };
export const btnGhost: React.CSSProperties = { background: "var(--surface-card)", color: "var(--ink-secondary)", padding: "8px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500, border: "1px solid var(--line-strong)", cursor: "pointer" };
export const inp: React.CSSProperties = { padding: "8px 11px", background: "var(--surface-input)", border: "1px solid var(--line-strong)", borderRadius: 8, color: "var(--ink)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
export const card: React.CSSProperties = { background: "var(--surface-card)", border: "1px solid var(--line)", borderRadius: 10 };

export function Badge({ tone, children }: { tone: "ok" | "warn" | "neutral" | "new"; children: React.ReactNode }) {
  // [bg, color, border]; "new" = contorno verde sem ponto (campo novo no portal)
  const c = {
    ok: ["var(--ok-soft)", "var(--ok)", "none"], warn: ["var(--warn-soft)", "var(--warn)", "none"],
    neutral: ["var(--surface-hover)", "var(--ink-mid)", "none"], new: ["transparent", "var(--ok)", "1px solid var(--ok-line)"],
  }[tone];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 5, height: 20, padding: "0 7px", borderRadius: 5, fontSize: 11, fontWeight: 600, background: c[0], color: c[1], border: c[2] }}>
      {tone !== "new" && <i style={{ width: 7, height: 7, borderRadius: "50%", background: "currentColor" }} />}{children}
    </span>
  );
}

export function XIcon({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <path d="M18 6L6 18M6 6l12 12" />
    </svg>
  );
}

export function Modal({ title, onClose, children, width = 440 }: { title: string; onClose: () => void; children: React.ReactNode; width?: number }) {
  return (
    <div {...backdropClose(onClose)} style={{ position: "fixed", inset: 0, background: "var(--overlay)", zIndex: "var(--z-modal)" as any, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <DialogPanel onClose={onClose} label={title} style={{ ...card, background: "var(--surface-card)", borderRadius: 12, boxShadow: "var(--shadow-modal)", width, maxWidth: "100%", padding: 22, display: "flex", flexDirection: "column", gap: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 16, fontWeight: 600 }}>{title}</span>
          <button aria-label="Fechar" onClick={onClose} style={{ color: "var(--ink-muted)", background: "none", border: "none", cursor: "pointer" }}><XIcon /></button>
        </div>
        {children}
      </DialogPanel>
    </div>
  );
}

// Toast simples no padrão do Valquiria (ink sobre card).
export function toast(text: string) {
  const d = document.createElement("div");
  d.textContent = text;
  Object.assign(d.style, {
    position: "fixed", bottom: "20px", left: "50%", transform: "translateX(-50%)", background: "var(--ink)", color: "var(--surface-card)",
    padding: "10px 16px", borderRadius: "8px", fontSize: "13px", boxShadow: "var(--shadow-pop)", zIndex: "var(--z-toast)",
  } as Partial<CSSStyleDeclaration>);
  document.body.appendChild(d);
  setTimeout(() => d.remove(), 2200);
}
